import { render, staticRenderFns } from "./main-banners.vue?vue&type=template&id=1f073708"
import script from "./main-banners.vue?vue&type=script&lang=js"
export * from "./main-banners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports